<app-loading-spinner [isLoading]="blockingOverlayVisible()" [text]="blockingOverlayText()"></app-loading-spinner>
<app-header class="pd-desktop-header" [title]="'Passport Details'" [filterDefinitions]="[]"></app-header>

<!-- Hidden Shared Inputs -->
<!-- Move inputs here so they are accessible to both mobile and desktop views -->
<label class="sr-only" for="haccp-camera">HACCP camera image</label>
<input #haccpCameraInput id="haccp-camera" type="file" accept="image/*" capture="environment" (change)="onHaccpImageSelected($event)" hidden />
<label class="sr-only" for="haccp-file">HACCP file upload</label>
<input #haccpFileInput id="haccp-file" type="file" accept="image/*" (change)="onHaccpImageSelected($event)" hidden />

<!-- Mobile View Wrapper -->
<div class="mobile-view" *ngIf="!accessDenied()">
  <div class="pd-header">
    <button class="chev" type="button" (click)="back()">
      <img src="/assets/images/Expand_Chevron.png" class="rot90" alt="Back">
    </button>
    <div class="pd-title">Passport Details</div>
    <div class="pd-actions">
      <button class="round" type="button" (click)="onHistoryClick()"><img src="/assets/images/History_Button.png" alt="History"></button>
      <button class="round" type="button" (click)="onCommentsClick()"><img src="/assets/images/Comments_Button.png" alt="Comments"></button>
    </div>
  </div>

  <div class="pd-content">
    <!-- Persona chooser -->
    <div class="edit-row" *ngIf="isScheduler || isAudit || (!isGrowerOrTransloader && !isGatehouse && !isReceiver && !isShunting)">
      <div class="edit-label">Choose Persona</div>
      <button class="filter-box origin-box" 
           type="button"
           (click)="$event.stopPropagation(); personaOpen = !personaOpen"
           (keydown.enter)="$event.stopPropagation(); personaOpen = !personaOpen"
           (keydown.space)="$event.stopPropagation(); $event.preventDefault(); personaOpen = !personaOpen">
        <span class="filter-input">{{ persona || 'Select' }}</span>
        <img class="filter-chevron" src="/assets/images/Filters_Chevron_Icon.png" alt="open">
        <div class="dropdown-panel" *ngIf="personaOpen" 
             (click)="$event.stopPropagation()"
             (keydown)="$event.stopPropagation()"
             role="menu">
          <div class="dropdown-options">
            <button class="option-btn" type="button" *ngFor="let p of ((isScheduler || isAudit) ? filteredSchedulerPersonaOptions : personaOptions)" (click)="onPersonaChange(p); personaOpen=false">{{ p }}</button>
          </div>
        </div>
      </button>
    </div>
    <div class="divider"></div>
    <div class="locked-list">
      @for (field of topLockedFields; track trackByLabel($index, field)) {
        <div class="locked-row">
          <span class="locked-label">{{ field.label }}</span>
          <span class="locked-value">{{ field.value }}</span>
        </div>
        <div class="divider"></div>
      }
      <!-- Scheduler Edit Mode (Grower): Show Shunting Yard at the end of locked-list, under Destination -->
      @if (persona === 'Grower' && (isScheduler || isAudit) && (isShuntingRequired || isAudit) && isEdit && mode === 'edit') {
        <div class="locked-row">
          <span class="locked-label">Shunting Yard</span>
          <span class="locked-value">{{ selectedShuntingYard || '-' }}</span>
        </div>
        <div class="divider"></div>
      }
    </div>

    <div class="edit-group" *ngIf="mode==='edit'; else viewOnlyInputs">
      <div class="edit-row" *ngIf="persona === 'Grower' && !isOriginLockedForTransfer; else originViewOnly" [class.invalid]="shouldMarkRequired && missingOrigin">
        <div class="edit-label">Origin</div>
        <div class="filter-box origin-box" 
             role="button"
             tabindex="0"
             (click)="toggleOrigin($event)"
             (keydown.enter)="toggleOrigin($event)"
             (keydown.space)="$event.preventDefault(); toggleOrigin($event)">
          <span class="filter-input">{{ (store.get(id)?.origin || '').trim() || 'No Origin Field' }}</span>
          <img class="filter-chevron" src="/assets/images/Filters_Chevron_Icon.png" alt="open">
          <div class="dropdown-panel" *ngIf="originOpen" 
               (click)="$event.stopPropagation()"
               (keydown)="$event.stopPropagation()"
               role="menu">
            <div class="dropdown-search-row">
              <label for="origin-dropdown-search" class="sr-only">Search Origins</label>
              <input id="origin-dropdown-search" class="dropdown-search" type="text" placeholder="Search" [(ngModel)]="dropdownSearch" autocomplete="off" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" (keydown.space)="$event.stopImmediatePropagation()" (keyup)="$event.stopPropagation()">
              <button class="dropdown-close" type="button" (click)="originOpen=false; dropdownSearch=''">×</button>
            </div>
            <div class="dropdown-options">
              <button class="option-btn" type="button" *ngFor="let opt of originOptions" [style.display]="!dropdownSearch || opt.toLowerCase().includes(dropdownSearch.toLowerCase()) ? 'flex' : 'none'" (click)="setOrigin(opt)">{{ opt }}</button>
            </div>
          </div>
        </div>
      </div>
      <ng-template #originViewOnly>
        <div class="edit-group-locked">
          <div class="locked-row">
            <span class="locked-label">Origin</span>
            <span class="locked-value">{{ store.get(id)?.origin || 'No Origin Field' }}</span>
          </div>
          <div class="divider"></div>
          <!-- Scheduler/Audit Edit Mode: Show Shunting Yard as locked/view-only field right after Origin -->
          <div class="locked-row" *ngIf="(isScheduler || isAudit) && (isShuntingRequired || isAudit) && isEdit">
            <span class="locked-label">Shunting Yard</span>
            <span class="locked-value">{{ selectedShuntingYard || '-' }}</span>
          </div>
          <div class="divider" *ngIf="(isScheduler || isAudit) && (isShuntingRequired || isAudit) && isEdit"></div>
        </div>
      </ng-template>

      <ng-container *ngIf="isGatehouse">
        @for (field of gatehouseViewFields; track trackByLabel($index, field)) {
          <div class="locked-row">
            <span class="locked-label">{{ field.label }}</span>
            <span class="locked-value">{{ field.value }}</span>
          </div>
          <div class="divider"></div>
        }
      </ng-container>

      <div class="edit-row" *ngIf="!isGatehouse" [class.invalid]="shouldMarkRequired && missingLoading">
        <label for="loading-datetime" class="edit-label">Loading Date and Time</label>
        <div class="origin-box date-box" 
             (click)="$event.stopPropagation()"
             (keydown)="$event.stopPropagation()">
          <input id="loading-datetime" #ldt class="filter-input date-input" type="datetime-local" [value]="loadingValue" (change)="setLoadingDateTime($any($event.target).value)" autocomplete="off" />
          <div class="date-overlay" (click)="openPicker(ldt)" (keydown.enter)="openPicker(ldt)" (keydown.space)="$event.preventDefault(); openPicker(ldt)">{{ loadingFormatted }}</div>
          <img class="date-end-icon" src="/assets/images/Calendar.png" alt="Calendar" (click)="openPicker(ldt)" (keydown.enter)="openPicker(ldt)" (keydown.space)="$event.preventDefault(); openPicker(ldt)" />
        </div>
      </div>

      <div class="edit-row" *ngIf="!isGatehouse" [class.invalid]="shouldMarkRequired && missingBulker">
        <label for="bulker-number-input" class="edit-label">Bulker Number</label>
        <div class="filter-box origin-box bulker-box" 
             (click)="$event.stopPropagation()"
             (keydown)="$event.stopPropagation()">
          <input id="bulker-number-input" class="filter-input text-input bulker-input" placeholder="Add Bulker Number" [value]="store.get(id)?.bulkerNumber || ''" (input)="setBulkerNumber($any($event.target).value)" autocomplete="off" />
        </div>
      </div>

      <div class="edit-row" *ngIf="!isGatehouse" [class.invalid]="shouldMarkRequired && missingHaccp">
        <div class="edit-label">HACCP Check <button class="info-btn" type="button" (click)="showHaccpInfo($event)"><img class="info-icon" src="/assets/images/Info.png" alt="Info"></button></div>
        <div class="info-banner" *ngIf="haccpInfoVisible" 
             (keydown)="$event.stopPropagation()">
          Please only conduct your HACCP checks through the hatch
        </div>
        <button class="filter-box origin-box haccp-box" 
             type="button"
             (click)="$event.stopPropagation(); haccpOpen = !haccpOpen"
             (keydown.enter)="$event.stopPropagation(); haccpOpen = !haccpOpen"
             (keydown.space)="$event.stopPropagation(); $event.preventDefault(); haccpOpen = !haccpOpen">
          <span class="filter-input">{{ computedHaccpCheck || 'Select' }}</span>
          <img class="filter-chevron" src="/assets/images/Filters_Chevron_Icon.png" alt="open">
          <div class="dropdown-panel" *ngIf="haccpOpen" 
               (click)="$event.stopPropagation()"
               (keydown)="$event.stopPropagation()"
               role="menu">
            <div class="dropdown-options">
              <button class="option-btn" type="button" (click)="setHaccp('Yes')">Yes</button>
              <button class="option-btn" type="button" (click)="setHaccp('No')">No</button>
            </div>
          </div>
          <button type="button" class="icon-button"
               [class.disabled]="computedHaccpCheck === 'No' || isUploadLimitReached"
               (click)="onHaccpCameraIconClick($event)"
               [attr.aria-label]="'Camera'">
            <img [src]="(computedHaccpCheck === 'No' || isUploadLimitReached) ? '/assets/images/Camera_Unselected.png' : '/assets/images/Camera_Selected.png'" alt="Camera" />
          </button>
          <!-- Use shared inputs -->
          <div class="dropdown-panel" *ngIf="haccpChoiceOpen" 
               (click)="$event.stopPropagation()"
               (keydown)="$event.stopPropagation()"
               role="menu">
            <div class="dropdown-options">
              <button class="option-btn" type="button" (click)="chooseHaccpCapture('camera', haccpCameraInput, haccpFileInput)">Take Photo</button>
              <button class="option-btn" type="button" (click)="chooseHaccpCapture('file', haccpCameraInput, haccpFileInput)">Upload Image</button>
            </div>
          </div>
        </button>
      </div>

      <div class="images" *ngIf="(displayedHaccpImages.length > 0 || emptyHaccpImagePlaceholders > 0) && !isShunting">
        <div class="img" *ngFor="let img of displayedHaccpImages; let i = index; trackBy: trackBySrc">
          <img [src]="img" alt="HACCP" (load)="onHaccpImageLoad(i)" (error)="onHaccpImageError(i)" (click)="openHaccpImagePreview(i, $event)" (keydown)="$event.key === 'Enter' && openHaccpImagePreview(i, $event)" class="clickable-image">
          <button class="close" type="button" (click)="removeHaccpImage(i); $event.stopPropagation()">✕</button>
        </div>
        <ng-container *ngFor="let _ of getEmptyPlaceholderArray(); let i = index">
          <div class="img empty-placeholder">
            <div class="empty-image-box">
              <span class="empty-image-text">Image {{ i + displayedHaccpImages.length + 1 }}</span>
            </div>
            <button class="close" type="button" (click)="removeEmptyPlaceholder(i + displayedHaccpImages.length); $event.stopPropagation()">✕</button>
          </div>
        </ng-container>
      </div>

      <div class="haccp-error-message" *ngIf="haccpMaxImagesError">
        Maximum image attachments reached (3/3)
      </div>
      <div class="haccp-error-message" *ngIf="haccpInvalidFileTypeError">
        Invalid file type. Only images (JPEG, PNG, GIF, WebP, BMP) are allowed.
      </div>
      <div class="haccp-error-message" *ngIf="haccpFileSizeError">
        File too large. Maximum size is 15MB per image.
      </div>

      <div class="edit-row" *ngIf="!isGatehouse">
        <div class="edit-label">Authorised By</div>
        <div class="filter-box origin-box"
             role="button"
             tabindex="0"
             (click)="$event.stopPropagation(); authorOpen = !authorOpen"
             (keydown.enter)="$event.stopPropagation(); authorOpen = !authorOpen"
             (keydown.space)="$event.stopPropagation(); $event.preventDefault(); authorOpen = !authorOpen">
          <span class="filter-input">{{ (store.get(id)?.authorisedBy || '').trim() || 'Select' }}</span>
          <img class="filter-chevron" src="/assets/images/Filters_Chevron_Icon.png" alt="open">
          <div class="dropdown-panel" *ngIf="authorOpen" 
               (click)="$event.stopPropagation()"
               (keydown)="$event.stopPropagation()"
               role="menu">
            <div class="dropdown-search-row">
              <label for="author-dropdown-search" class="sr-only">Search or add authoriser name</label>
              <input id="author-dropdown-search"
                     class="dropdown-search"
                     type="text"
                     placeholder="Search or add name"
                     [(ngModel)]="authorSearch"
                     autocomplete="off"
                     (click)="$event.stopPropagation()"
                     (keydown)="$event.stopPropagation()"
                     (keydown.space)="$event.stopImmediatePropagation()"
                     (keyup)="$event.stopPropagation()">
              <button class="dropdown-close" type="button" (click)="authorOpen=false; authorSearch=''">×</button>
            </div>
              <div class="dropdown-options">
                <button class="option-btn" type="button"
                        *ngFor="let opt of filteredAuthorisedByOptions"
                        (click)="setAuthorisedBy(opt)">{{ opt }}</button>
                <button class="option-btn" type="button"
                        *ngIf="canAddAuthorSearch && canAddAuthorizer"
                        [disabled]="isAddingAuthorizer()"
                        (click)="addAuthorisedBy(authorSearch)">
                  <span *ngIf="!isAddingAuthorizer()">Add "{{ authorSearch }}"</span>
                  <span *ngIf="isAddingAuthorizer()">Adding...</span>
                </button>
                <div class="option-btn" style="pointer-events: none; color: #666;" *ngIf="filteredAuthorisedByOptions.length === 0 && !(canAddAuthorSearch && canAddAuthorizer)">No user found</div>
              </div>
          </div>
        </div>
      </div>

      <!-- Shunting Yard (read-only) for Gatehouse in mobile edit mode -->
      <div class="locked-row" *ngIf="isGatehouse && isShuntingRequired">
        <span class="locked-label">Shunting Yard</span>
        <span class="locked-value">{{ selectedShuntingYard || '-' }}</span>
      </div>
      <div class="divider" *ngIf="isGatehouse && isShuntingRequired"></div>

      <div class="edit-row" *ngIf="isScheduler && isEdit">
        <label for="reason-textarea" class="edit-label">Reason</label>
        <div class="filter-box origin-box reason-box" 
             (click)="$event.stopPropagation()"
             (keydown)="$event.stopPropagation()">
          <textarea id="reason-textarea" class="filter-input text-input" placeholder="Add Reason Details" [(ngModel)]="reasonText" rows="3" autocomplete="off"></textarea>
        </div>
      </div>
      <div class="authorised-note">
        By clicking Submit you align to the post loading foreign object free, chemical usage, Red Tractor assurance and quality declaration.
      </div>
    </div>

    <ng-template #viewOnlyInputs>
      <div class="locked-list">
        @for (field of viewOnlyFields; track trackByLabel($index, field); let isLast = $last; let idx = $index) {
          <div class="locked-row">
            <span class="locked-label">{{ field.label }}</span>
            <span class="locked-value">{{ field.value }}</span>
          </div>

          @if (field.label === 'HACCP Check' && displayedHaccpImages.length && !isShunting) {
            <div class="images">
              <div class="img" *ngFor="let img of displayedHaccpImages; let i = index; trackBy: trackBySrc">
                <img [src]="img" alt="HACCP" (load)="onHaccpImageLoad(i)" (error)="onHaccpImageError(i)" (click)="openHaccpImagePreview(i, $event)" (keydown)="$event.key === 'Enter' && openHaccpImagePreview(i, $event)" class="clickable-image">
              </div>
            </div>
          }

          <div class="divider"></div>

          <!-- Editable Shunting Yard dropdown for Scheduler (view mode, non-receiving) and Gatehouse (non-receiving) -->
          @if (field.label === 'Authorised By' && ((isScheduler && !isReceivingTab) || (isGatehouse && !isReceivingTab)) && isShuntingRequired) {
            <div class="edit-row">
              <div class="edit-label">Shunting Yard</div>
              <button class="filter-box origin-box yard-box" type="button"
                   (click)="$event.stopPropagation(); yardOpen = !yardOpen"
                   (keydown.enter)="$event.stopPropagation(); yardOpen = !yardOpen"
                   (keydown.space)="$event.stopPropagation(); $event.preventDefault(); yardOpen = !yardOpen">
                <span class="filter-input" [class.placeholder]="!selectedShuntingYard">
                  {{ selectedShuntingYard || 'Select' }}
                </span>
                <img class="filter-chevron" src="/assets/images/Filters_Chevron_Icon.png" alt="open">
                <div class="dropdown-panel" *ngIf="yardOpen"
                     (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" role="menu">
                  <div class="dropdown-options">
                    <button class="option-btn" type="button"
                            *ngFor="let opt of shuntingYardsDisplay"
                            (click)="setShuntingYard(opt)">{{ opt }}</button>
                  </div>
                </div>
              </button>
            </div>
            <div class="divider"></div>
          }
          <!-- Read-only Shunting Yard for Audit or Receiving tab -->
          @if (field.label === 'Authorised By' && (isAudit || ((isGatehouse || isScheduler) && isReceivingTab)) && isShuntingRequired) {
            <div class="locked-row">
              <span class="locked-label">Shunting Yard</span>
              <span class="locked-value">{{ selectedShuntingYard || '-' }}</span>
            </div>
            <div class="divider"></div>
          }
        }
      </div>
    </ng-template>

    <div class="page-actions" *ngIf="mode==='edit' && !isReceiver && !isShunting">
      <ng-container *ngIf="!isGatehouse && !isScheduler; else personaSpecific">
        <button class="outline" type="button" [disabled]="isSavingDraft()" (click)="saveDraft()">
          <span *ngIf="!isSavingDraft()">Draft</span>
          <span *ngIf="isSavingDraft()">Saving...</span>
        </button>
        <button class="outline filled" type="button" [disabled]="!canSubmit" (click)="onSubmit()">Submit</button>
      </ng-container>
      <ng-template #personaSpecific>
        <button class="outline filled" type="button" [disabled]="!canSubmit" (click)="onSubmit()">Submit</button>
      </ng-template>
    </div>

    <!-- Gatehouse: in view mode show Proceed button -->
    <div class="page-actions" *ngIf="isGatehouse && mode==='view' && !isReceiver && !isShunting">
      <button class="outline filled" type="button" (click)="onAdvancePassport()">Proceed</button>
    </div>

    <!-- Scheduler: in view mode show Edit + Submit (Submit will be disabled until required) -->
    <div class="page-actions" *ngIf="isScheduler && mode==='view' && !isReceiver && !isShunting">
      <button class="outline" type="button" (click)="startSchedulerEdit()">Edit</button>
      <button class="outline filled" type="button" [disabled]="!canSubmit" (click)="onSubmit()">Submit</button>
    </div>

    <div class="page-actions" *ngIf="isReceiver && mode==='view' && canCompleteReceiving">
      <button class="outline filled" type="button" [disabled]="isCompletingReceiving()" (click)="onCompleteReceiving()">
        <span *ngIf="!isCompletingReceiving()">Complete</span>
        <span *ngIf="isCompletingReceiving()">Saving...</span>
      </button>
    </div>
  </div>
</div>

<!-- Desktop View Wrapper -->
<div class="desktop-view" *ngIf="!accessDenied()">
  <!-- Header Box -->
  <div class="desktop-header-box">
    <div class="desktop-header-left">
      <button class="desktop-back-btn" (click)="back()">
        <img src="/assets/images/Chevron_Left.png" alt="Back">
      </button>
      <div class="desktop-page-title">Passport Details</div>
    </div>
    <div class="desktop-header-right">
      <button class="desktop-action-btn" (click)="onHistoryClick()">History</button>
      <button class="desktop-action-btn" (click)="onCommentsClick()">Comments</button>
    </div>
  </div>

  <!-- Content Box -->
  <div class="desktop-content-box">

    <!-- Scheduler Persona Dropdown -->
    <div class="desktop-edit-row scheduler-persona-row" *ngIf="isScheduler || isAudit">
      <div class="desktop-label-edit">Choose Persona</div>
      <button class="desktop-dropdown" (click)="personaOpen = !personaOpen; $event.stopPropagation()">
        <span class="desktop-input-text">{{ persona || 'Select' }}</span>
        <img class="desktop-end-icon" src="/assets/images/Filters_Chevron_Icon.png" alt="Expand">
        <div class="dropdown-panel" *ngIf="personaOpen" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <div class="dropdown-options">
            <button class="option-btn" type="button" *ngFor="let p of filteredSchedulerPersonaOptions" (click)="onPersonaChange(p); personaOpen=false">{{ p }}</button>
          </div>
        </div>
      </button>
    </div>

    <!-- Template for Fixed Fields (Reusable) -->
    <ng-template #fixedFieldsTemplate>
      <!-- Row 1 -->
      <div class="desktop-fixed-field">
        <div class="desktop-label-fixed">Load Number</div>
        <div class="desktop-value-fixed">{{ store.get(id)?.loadNumber }}</div>
      </div>
      <div class="desktop-fixed-field">
        <div class="desktop-label-fixed">Vendor Number</div>
        <div class="desktop-value-fixed">{{ store.get(id)?.vendorNumber || '-' }}</div>
      </div>

      <!-- Row 2 -->
      <div class="desktop-fixed-field">
        <div class="desktop-label-fixed">Scheduled Date & Time</div>
        <div class="desktop-value-fixed">{{ (store.get(id)?.dueDateTime | dateWithOrdinal:'EEE, d MMM y, HH:mm') || '-' }}</div>
      </div>
      <div class="desktop-fixed-field">
        <div class="desktop-label-fixed">APN / Name</div>
        <div class="desktop-value-fixed">{{ store.get(id)?.apnName ? (store.get(id)?.apn + ' - ' + store.get(id)?.apnName) : (store.get(id)?.apn || '-') }}</div>
      </div>

      <!-- Row 3 -->
      <div class="desktop-fixed-field">
        <div class="desktop-label-fixed">Variety</div>
        <div class="desktop-value-fixed">{{ store.get(id)?.variety || '-' }}</div>
      </div>
      <div class="desktop-fixed-field">
        <div class="desktop-label-fixed">Haulier</div>
        <div class="desktop-value-fixed">{{ store.get(id)?.haulier }}</div>
      </div>

      <!-- Row 4 -->
      <div class="desktop-fixed-field">
        <div class="desktop-label-fixed">Vendor Name</div>
        <div class="desktop-value-fixed">{{ store.get(id)?.vendorName }}</div>
      </div>
      <div class="desktop-fixed-field">
        <div class="desktop-label-fixed">Destination</div>
        <div class="desktop-value-fixed">{{ store.get(id)?.destinationWeighbridge || store.get(id)?.destination }}</div>
      </div>

      <!-- Row 5: Shunting Yard for Scheduler/Audit Edit Mode (Grower persona) - under Vendor Name -->
      <ng-container *ngIf="persona === 'Grower' && (isScheduler || isAudit) && (isShuntingRequired || isAudit) && isEdit">
        <div class="desktop-fixed-field">
          <div class="desktop-label-fixed">Shunting Yard</div>
          <div class="desktop-value-fixed">{{ selectedShuntingYard || '-' }}</div>
        </div>
        <!-- Empty spacer for grid alignment -->
        <div class="desktop-fixed-field" style="border-bottom: none;">
        </div>
      </ng-container>

      <!-- Row 5: Origin locked for Transloading persona only -->
      <ng-container *ngIf="persona === 'Transloader'">
        <div class="desktop-fixed-field">
          <div class="desktop-label-fixed">Origin</div>
          <div class="desktop-value-fixed">{{ store.get(id)?.origin || 'No Origin Field' }}</div>
        </div>
        <!-- Shunting Yard for Scheduler/Audit Edit Mode - locked field to the right of Origin -->
        <div class="desktop-fixed-field" *ngIf="(isScheduler || isAudit) && (isShuntingRequired || isAudit) && isEdit">
          <div class="desktop-label-fixed">Shunting Yard</div>
          <div class="desktop-value-fixed">{{ selectedShuntingYard || '-' }}</div>
        </div>
        <!-- Empty spacer for grid alignment when not in Scheduler/Audit Edit Mode -->
        <div class="desktop-fixed-field" *ngIf="(!isScheduler && !isAudit) || (!isShuntingRequired && !isAudit) || !isEdit" style="border-bottom: none;">
        </div>
      </ng-container>

      <!-- Row 5: Origin + Shunting Yard for transferred loads (Scheduler persona, edit mode only) -->
      <ng-container *ngIf="isOriginLockedForTransfer && persona === 'Scheduler' && isEdit">
        <div class="desktop-fixed-field">
          <div class="desktop-label-fixed">Origin</div>
          <div class="desktop-value-fixed">{{ store.get(id)?.origin || 'No Origin Field' }}</div>
        </div>
        <div class="desktop-fixed-field" *ngIf="(isScheduler || isAudit) && (isShuntingRequired || isAudit)">
          <div class="desktop-label-fixed">Shunting Yard</div>
          <div class="desktop-value-fixed">{{ selectedShuntingYard || '-' }}</div>
        </div>
        <div class="desktop-fixed-field" *ngIf="(!isScheduler && !isAudit) || (!isShuntingRequired && !isAudit)" style="border-bottom: none;">
        </div>
      </ng-container>
    </ng-template>

    <!-- EDIT MODE: Fixed Fields Grid at Top -->
    <div class="desktop-fixed-grid" *ngIf="mode === 'edit'">
      <ng-container *ngTemplateOutlet="fixedFieldsTemplate"></ng-container>
    </div>

    <!-- Editable Fields (Only in Edit Mode) -->
    <div class="desktop-editable-section" *ngIf="mode === 'edit'">

      <!-- Left Column -->
      <div class="desktop-edit-col-left">
        <!-- Origin (Editable for Grower, not on Transferred tab) -->
        <div class="desktop-edit-row" *ngIf="persona === 'Grower' && !isTransferredReadonly && !isOriginLockedForTransfer">
          <div class="desktop-label-edit">Origin</div>
          <!-- Match mobile Origin dropdown look/feel (blue bordered panel + search) -->
          <div class="filter-box origin-box"
               role="button"
               tabindex="0"
               (click)="toggleOrigin($event)"
               (keydown.enter)="toggleOrigin($event)"
               (keydown.space)="$event.preventDefault(); toggleOrigin($event)">
            <span class="filter-input">{{ (store.get(id)?.origin || '').trim() || 'No Origin Field' }}</span>
            <img class="filter-chevron" src="/assets/images/Filters_Chevron_Icon.png" alt="open">
            <div class="dropdown-panel" *ngIf="originOpen"
                 (click)="$event.stopPropagation()"
                 (keydown)="$event.stopPropagation()"
                 role="menu">
              <div class="dropdown-search-row">
                <label for="desktop-origin-dropdown-search" class="sr-only">Search Origins</label>
                <input id="desktop-origin-dropdown-search"
                       class="dropdown-search"
                       type="text"
                       placeholder="Search"
                       [(ngModel)]="dropdownSearch"
                       autocomplete="off"
                       (click)="$event.stopPropagation()"
                       (keydown)="$event.stopPropagation()"
                       (keydown.space)="$event.stopImmediatePropagation()"
                       (keyup)="$event.stopPropagation()">
                <button class="dropdown-close" type="button" (click)="originOpen=false; dropdownSearch=''">×</button>
              </div>
              <div class="dropdown-options">
                <button class="option-btn"
                        type="button"
                        *ngFor="let opt of originOptions"
                        [style.display]="!dropdownSearch || opt.toLowerCase().includes(dropdownSearch.toLowerCase()) ? 'flex' : 'none'"
                        (click)="setOrigin(opt)">{{ opt }}</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Loading D/T (Read-only for Transferred Scheduler) -->
        <div class="desktop-edit-row" *ngIf="!isGatehouse && isTransferredReadonly">
          <div class="desktop-label-edit">Loading Date and Time</div>
          <div class="desktop-value-fixed">{{ loadingFormatted || '-' }}</div>
        </div>

        <!-- Loading D/T (Editable) -->
        <div class="desktop-edit-row" *ngIf="!isGatehouse && !isTransferredReadonly">
          <label class="desktop-label-edit" for="desktop-loading-datetime">Loading Date and Time</label>
          <div class="desktop-dropdown desktop-date-dropdown" (click)="openPicker(desktopLdt)" (keydown.enter)="openPicker(desktopLdt)" (keydown.space)="$event.preventDefault(); openPicker(desktopLdt)">
            <span class="desktop-input-text desktop-date-text" [class.placeholder]="!loadingFormatted">{{ loadingFormatted || 'Select' }}</span>
            <input #desktopLdt id="desktop-loading-datetime" type="datetime-local" class="native-select" [value]="loadingValue" (change)="setLoadingDateTime($any($event.target).value)">
            <img class="desktop-end-icon desktop-calendar-icon" src="/assets/images/Calendar.png" alt="Calendar">
          </div>
        </div>

        <!-- Bulker Number (Read-only for Transferred Scheduler) -->
        <div class="desktop-edit-row" *ngIf="!isGatehouse && isTransferredReadonly">
          <div class="desktop-label-edit">Bulker Number</div>
          <div class="desktop-value-fixed">{{ displayBulkerNumber || '-' }}</div>
        </div>

        <!-- Bulker Number (Editable) -->
        <div class="desktop-edit-row" *ngIf="!isGatehouse && !isTransferredReadonly">
          <label class="desktop-label-edit" for="desktop-bulker-number">Bulker Number</label>
          <input
            id="desktop-bulker-number"
            class="desktop-text-input desktop-bulker-input"
            [value]="store.get(id)?.bulkerNumber || ''"
            (input)="setBulkerNumber($any($event.target).value)"
            placeholder="Add Bulker Number">
        </div>

        <!-- Authorised By (Read-only for Transferred Scheduler) -->
        <div class="desktop-edit-row" *ngIf="!isGatehouse && isTransferredReadonly">
          <div class="desktop-label-edit">Authorised By</div>
          <div class="desktop-value-fixed">{{ (store.get(id)?.authorisedBy || '').trim() || '-' }}</div>
        </div>

        <!-- Authorised By (Editable) -->
        <div class="desktop-edit-row" *ngIf="!isGatehouse && !isTransferredReadonly">
          <div class="desktop-label-edit">Authorised By</div>
          <div class="desktop-dropdown"
               role="button"
               tabindex="0"
               (click)="authorOpen = !authorOpen; $event.stopPropagation()"
               (keydown.enter)="authorOpen = !authorOpen; $event.stopPropagation()"
               (keydown.space)="$event.preventDefault(); authorOpen = !authorOpen; $event.stopPropagation()">
            <span class="desktop-input-text">{{ (store.get(id)?.authorisedBy || '').trim() || 'Select' }}</span>
            <img class="desktop-end-icon" src="/assets/images/Filters_Chevron_Icon.png" alt="Expand">
            <div class="dropdown-panel" *ngIf="authorOpen" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <div class="dropdown-search-row">
                <label class="sr-only" for="desktop-author-search">Search or add authoriser name</label>
                <input id="desktop-author-search"
                       class="dropdown-search"
                       type="text"
                       placeholder="Search or add name"
                       [(ngModel)]="authorSearch"
                       (click)="$event.stopPropagation()"
                       (keydown)="$event.stopPropagation()"
                       (keydown.space)="$event.stopImmediatePropagation()"
                       (keyup)="$event.stopPropagation()">
              </div>
                <div class="dropdown-options">
                  <button class="option-btn" type="button" *ngFor="let opt of filteredAuthorisedByOptions" (click)="setAuthorisedBy(opt)">{{ opt }}</button>
                  <button class="option-btn" type="button" *ngIf="canAddAuthorSearch && canAddAuthorizer" [disabled]="isAddingAuthorizer()" (click)="addAuthorisedBy(authorSearch)">
                    <span *ngIf="!isAddingAuthorizer()">Add "{{ authorSearch }}"</span>
                    <span *ngIf="isAddingAuthorizer()">Adding...</span>
                  </button>
                  <div class="option-btn" style="pointer-events: none; color: #666;" *ngIf="filteredAuthorisedByOptions.length === 0 && !(canAddAuthorSearch && canAddAuthorizer)">No user found</div>
                </div>
            </div>
          </div>
        </div>

        <!-- Shunting Yard (read-only) for Gatehouse in desktop edit mode -->
        <div class="desktop-fixed-field" *ngIf="isGatehouse && isShuntingRequired">
          <div class="desktop-label-fixed">Shunting Yard</div>
          <div class="desktop-value-fixed">{{ selectedShuntingYard || '-' }}</div>
        </div>
      </div>

      <!-- Right Column -->
      <div class="desktop-edit-col-right">
        <!-- HACCP Check (Read-only for Transferred Scheduler) -->
        <div class="desktop-edit-row" *ngIf="!isGatehouse && isTransferredReadonly">
          <div class="desktop-label-edit">HACCP Check</div>
          <div class="desktop-value-fixed">{{ computedHaccpCheck || '-' }}</div>
        </div>

        <!-- HACCP Check (Editable) -->
        <div class="desktop-edit-row" *ngIf="!isGatehouse && !isTransferredReadonly">
          <div class="info-banner" *ngIf="haccpInfoVisible" style="margin-bottom: 10px;">
            Please only conduct your HACCP checks through the hatch
          </div>
          <div class="desktop-label-edit">
            HACCP Check 
            <img class="info-icon" src="/assets/images/Info.png" alt="Info" (click)="showHaccpInfo($event)" (keydown.enter)="showHaccpInfo($event)" (keydown.space)="$event.preventDefault(); showHaccpInfo($event)">
          </div>
          <button class="desktop-dropdown" (click)="haccpOpen = !haccpOpen; $event.stopPropagation()">
            <span class="desktop-input-text">{{ computedHaccpCheck || 'Select' }}</span>
            <img class="desktop-end-icon" src="/assets/images/Filters_Chevron_Icon.png" alt="Expand" style="right: 44px">
            <!-- Direct upload icon at the end - disabled when HACCP is "No" or max images reached -->
            <img 
              class="desktop-end-icon" 
              [class.clickable]="computedHaccpCheck === 'Yes' && !isUploadLimitReached"
              [class.disabled-icon]="computedHaccpCheck === 'No' || isUploadLimitReached"
              [src]="(computedHaccpCheck === 'No' || isUploadLimitReached) ? '/assets/images/Upload_Disabled.png' : '/assets/images/Upload.png'" 
              [alt]="(computedHaccpCheck === 'No' || isUploadLimitReached) ? 'Upload Disabled' : 'Upload'"
              (click)="(computedHaccpCheck === 'Yes' && !isUploadLimitReached) && chooseHaccpCapture('file', haccpCameraInput, haccpFileInput); $event.stopPropagation()" 
              (keydown.enter)="(computedHaccpCheck === 'Yes' && !isUploadLimitReached) && chooseHaccpCapture('file', haccpCameraInput, haccpFileInput); $event.stopPropagation()" 
              (keydown.space)="$event.preventDefault(); (computedHaccpCheck === 'Yes' && !isUploadLimitReached) && chooseHaccpCapture('file', haccpCameraInput, haccpFileInput); $event.stopPropagation()">

            <div class="dropdown-panel" *ngIf="haccpOpen" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <div class="dropdown-options">
                <button class="option-btn" type="button" (click)="setHaccpDesktop('Yes')">Yes</button>
                <button class="option-btn" type="button" (click)="setHaccp('No')">No</button>
              </div>
            </div>
          </button>

          <!-- HACCP Images Container (Moved inside the row to sit under the dropdown) -->
          <div class="desktop-haccp-container" *ngIf="displayedHaccpImages.length > 0 || haccpMaxImagesError || haccpInvalidFileTypeError || haccpFileSizeError">
            <div class="images desktop-haccp-images" *ngIf="displayedHaccpImages.length > 0">
              <div class="img" *ngFor="let img of displayedHaccpImages; let i = index">
                <img [src]="img" alt="HACCP" (load)="onHaccpImageLoad(i)" (error)="onHaccpImageError(i)" (click)="openHaccpImagePreview(i, $event)" (keydown.enter)="openHaccpImagePreview(i, $event)" class="clickable-image">
                <button class="close" type="button" (click)="removeHaccpImage(i)">✕</button>
              </div>
            </div>
            <div class="haccp-error-message" *ngIf="haccpMaxImagesError" style="margin-top: 8px;">Maximum image attachments reached (3/3)</div>
            <div class="haccp-error-message" *ngIf="haccpInvalidFileTypeError" style="margin-top: 8px;">Invalid file type. Only images (JPEG, PNG, GIF, WebP, BMP) are allowed.</div>
            <div class="haccp-error-message" *ngIf="haccpFileSizeError" style="margin-top: 8px;">File too large. Maximum size is 15MB per image.</div>
          </div>
        </div>

        <!-- Reason Field (Scheduler Edit Mode - Below HACCP) -->
        <div class="desktop-edit-row" *ngIf="isScheduler">
          <label class="desktop-label-edit" for="desktop-reason-textarea">Reason</label>
          <textarea
            id="desktop-reason-textarea"
            class="desktop-text-input desktop-reason-textarea"
            [(ngModel)]="reasonText"
            placeholder="Add Reason Details"
            rows="3"></textarea>
        </div>
      </div>
    </div>

    <!-- VIEW MODE: Split Layout (Left: Fixed Fields, Right: View Fields) -->
    <div class="desktop-view-split" *ngIf="mode === 'view'">
      <!-- Left Column: 8 Fixed Fields + Editable Shunting Yard dropdown at bottom -->
      <div class="desktop-view-left">
        <ng-container *ngTemplateOutlet="fixedFieldsTemplate"></ng-container>

        <!-- Editable Shunting Yard for Scheduler (view, non-receiving) and Gatehouse (non-receiving) - placed at bottom of left column -->
        <div class="desktop-edit-row" *ngIf="((isScheduler && !isReceivingTab) || (isGatehouse && !isReceivingTab)) && isShuntingRequired">
          <div class="desktop-label-edit">Shunting Yard</div>
          <button class="desktop-dropdown"
                  (click)="yardOpen = !yardOpen; $event.stopPropagation()">
            <span class="desktop-input-text">{{ selectedShuntingYard || 'Select' }}</span>
            <img class="desktop-end-icon" src="/assets/images/Filters_Chevron_Icon.png" alt="Expand">
            <div class="dropdown-panel" *ngIf="yardOpen"
                 (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <div class="dropdown-options">
                <button class="option-btn" type="button"
                        *ngFor="let opt of shuntingYardsDisplay"
                        (click)="setShuntingYard(opt)">{{ opt }}</button>
              </div>
            </div>
          </button>
        </div>
      </div>

      <!-- Right Column: 5 Dynamic Fields -->
      <div class="desktop-view-right">
        <!-- Origin (View mode - Transloader has it in fixed section) -->
        <div class="desktop-fixed-field" *ngIf="persona === 'Grower' || persona === 'Receiver' || persona === 'Shunting' || persona === 'Gatehouse' || persona === 'Scheduler'">
          <div class="desktop-label-fixed">Origin</div>
          <div class="desktop-value-fixed">{{ store.get(id)?.origin || 'No Origin Field' }}</div>
        </div>

        <!-- Loading D/T -->
        <div class="desktop-fixed-field">
          <div class="desktop-label-fixed">Loading Date and Time</div>
          <div class="desktop-value-fixed">{{ loadingFormatted || '-' }}</div>
        </div>

        <!-- Bulker Number -->
        <div class="desktop-fixed-field">
          <div class="desktop-label-fixed">Bulker Number</div>
          <div class="desktop-value-fixed">{{ displayBulkerNumber || '-' }}</div>
        </div>

        <!-- HACCP Check -->
        <div class="desktop-fixed-field">
          <div class="desktop-label-fixed">HACCP Check</div>
          <div class="desktop-value-fixed">{{ computedHaccpCheck || '-' }}</div>
        </div>

        <!-- HACCP Images (Placed under check, but inside field logic? No, images usually own row in view mode or inside field) -->
        <!-- To match right align, images should be under the value or separate row. -->
        <!-- User said: "Make sure the same order as the image is followed." -->
        <!-- "HACCP Check" (Label left) ... "Yes" (Value right) -->
        <!-- Images below it. -->
        <div class="images desktop-haccp-images" *ngIf="displayedHaccpImages.length > 0 && !isShunting" style="margin-top: 0; padding-bottom: 12px; border-bottom: 1px solid #E7E7E7;">
          <div class="img" *ngFor="let img of displayedHaccpImages; let i = index">
            <img [src]="img" alt="HACCP" (load)="onHaccpImageLoad(i)" (error)="onHaccpImageError(i)" (click)="openHaccpImagePreview(i, $event)" (keydown.enter)="openHaccpImagePreview(i, $event)" class="clickable-image">
          </div>
        </div>

        <!-- Authorised By -->
        <div class="desktop-fixed-field">
          <div class="desktop-label-fixed">Authorised By</div>
          <div class="desktop-value-fixed">{{ store.get(id)?.authorisedBy || '-' }}</div>
        </div>

        <!-- Read-only Shunting Yard for Audit or Receiving tab (stays in right column) -->
        <div class="desktop-fixed-field" *ngIf="(isAudit || ((isGatehouse || isScheduler) && isReceivingTab)) && isShuntingRequired">
          <div class="desktop-label-fixed">Shunting Yard</div>
          <div class="desktop-value-fixed">{{ selectedShuntingYard || '-' }}</div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="desktop-legal" *ngIf="mode === 'edit'">
      By clicking Submit you align to the post loading foreign object free, chemical usage, Red Tractor assurance and quality declaration.
    </div>

    <div class="desktop-footer-actions" *ngIf="mode==='edit' && !isReceiver && !isShunting">
      <ng-container *ngIf="!isGatehouse && !isScheduler; else personaSpecificDesktop">
        <button class="desktop-footer-btn draft" [disabled]="isSavingDraft()" (click)="saveDraft()">
          <span *ngIf="!isSavingDraft()">Draft</span>
          <span *ngIf="isSavingDraft()">Saving...</span>
        </button>
        <button class="desktop-footer-btn submit" [disabled]="!canSubmit" (click)="onSubmit()">Submit</button>
      </ng-container>
      <ng-template #personaSpecificDesktop>
        <button class="desktop-footer-btn submit" [disabled]="!canSubmit" (click)="onSubmit()">Submit</button>
      </ng-template>
    </div>

    <!-- Gatehouse Footer Actions (Desktop) - Hidden when from receiving tab -->
    <div class="desktop-footer-actions" *ngIf="isGatehouse && mode==='view' && !isReceiver && !isShunting && !isReceivingTab" style="justify-content: center;">
      <button class="desktop-footer-btn submit" (click)="onAdvancePassport()">Proceed</button>
    </div>

    <!-- Scheduler Footer Actions (Desktop) -->
    <div class="desktop-footer-actions" *ngIf="isScheduler && mode==='view' && !isReceiver && !isShunting" style="justify-content: center; gap: 16px;">
      <button class="desktop-footer-btn draft" (click)="startSchedulerEdit()">Edit</button>
      <button class="desktop-footer-btn submit" [disabled]="!canSubmit" (click)="onSubmit()">Submit</button>
    </div>

    <div class="desktop-footer-actions" *ngIf="isReceiver && mode==='view' && canCompleteReceiving" style="justify-content: center;">
      <button class="desktop-footer-btn submit" type="button" [disabled]="isCompletingReceiving()" (click)="onCompleteReceiving()">
        <span *ngIf="!isCompletingReceiving()">Complete</span>
        <span *ngIf="isCompletingReceiving()">Saving...</span>
      </button>
    </div>
  </div>
</div>

<!-- Image Preview Modal (Shared) -->
<div class="image-preview-backdrop" *ngIf="previewImageIndex !== null" (click)="closeHaccpImagePreview()" (keydown.escape)="closeHaccpImagePreview()">
  <button class="image-preview-close" (click)="closeHaccpImagePreview()">×</button>
  <div class="image-preview-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <img [src]="previewImageSrc" alt="HACCP" class="image-preview-img">
    <div class="image-preview-nav" *ngIf="displayedHaccpImages.length > 1">
      <button class="image-preview-nav-btn" (click)="prevPreviewImage($event)">‹</button>
      <span class="image-preview-counter">{{ previewImageIndex + 1 }} / {{ displayedHaccpImages.length }}</span>
      <button class="image-preview-nav-btn" (click)="nextPreviewImage($event)">›</button>
    </div>
  </div>
</div>

<!-- Submit Success Modal (Shared) -->
<div class="submit-modal-backdrop" *ngIf="submitModalVisible">
  <div class="submit-modal">
    <div class="submit-title">Passport Submitted!</div>
    <div class="submit-msg">Your passport has been successfully submitted.</div>
    <button class="submit-ok" (click)="closeSubmitModal()">OK</button>
  </div>